var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileIdLogo = function SvgMobileIdLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobileIdLogo_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentCOlor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.1 7.3-3 8.2-3-8.2H1.8V22h3.9V12l3.6 10h2.8L16 12v10h4V7.3h-5.9Zm-3-7.3C7.6 0 5 2.3 4.6 5.7h3.7A3 3 0 0 1 11 3.5c1.5 0 2.5.9 2.9 2.2h3.7C17.3 2.3 14.7 0 11 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobileIdLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};

export default SvgMobileIdLogo;